import React from 'react';
import { bookData } from '../data/mockData';
import { CheckCircle2 } from 'lucide-react';

const AboutBookSection = () => {
  return (
    <section id="sobre-libro" className="py-24 lg:py-32 bg-[#1a1c1b]">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-lg">
              <img
                src="https://images.unsplash.com/photo-1585757318177-0570a997dc3a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxmb290YmFsbCUyMGNvYWNofGVufDB8fHx8MTc3NjEyOTQ0NXww&ixlib=rb-4.1.0&q=85"
                alt="About the book"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1a1c1b] via-transparent to-transparent"></div>
            </div>
            
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-[#d9fb06] opacity-10 rounded-full blur-3xl"></div>
          </div>

          {/* Content */}
          <div>
            <div className="mb-6">
              <span className="caption text-[#d9fb06] bg-[#3f4816] px-4 py-2 rounded-full">
                SOBRE EL LIBRO
              </span>
            </div>

            <h2 className="heading-2 text-[#d9fb06] mb-6">
              Construye tu Marca Personal desde el Primer Día
            </h2>

            <p className="body-medium text-[#888680] mb-8 leading-relaxed">
              {bookData.description}
            </p>

            <div className="space-y-4 mb-8">
              {bookData.features.map((feature, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle2 className="text-[#d9fb06] mt-1 flex-shrink-0" size={24} />
                  <span className="body-small text-[#dfddd6]">{feature}</span>
                </div>
              ))}
            </div>

            <div className="bg-[#302f2c] border border-[#3f4816] rounded-lg p-6">
              <p className="text-[#d9fb06] font-semibold mb-2">
                Incluye Cuaderno de Desarrollo Personal
              </p>
              <p className="body-small text-[#888680]">
                Con ejercicios prácticos, plantillas y herramientas para crear 
                tu plan de desarrollo de marca personal en los primeros 90 días.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutBookSection;
